import type {ReactElement} from 'react';
import {ColorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/color-control/color-control';
import {DEFAULT_BORDER_COLOR} from '@FormMakerReact/layout/form-maker-right-panel/sectors/submit-button-sector/submit-button-sector.types';
import type {SubmitButtonBorderColorControlProps} from './submit-button-border-color-control.types';

export function SubmitButtonBorderColorControl({component}: SubmitButtonBorderColorControlProps): ReactElement {
  return (
    <ColorControl
      component={component}
      property="border-color"
      labelKey="pmwjs_form_maker_control_border_color_label"
      pickAriaKey="pmwjs_form_maker_control_border_color_pick"
      clearAriaKey="pmwjs_form_maker_control_border_color_clear"
      defaultColor={DEFAULT_BORDER_COLOR}
    />
  );
}
